import { render, staticRenderFns } from "./pendientesGestionar.vue?vue&type=template&id=68f00540&"
import script from "./pendientesGestionar.vue?vue&type=script&lang=js&"
export * from "./pendientesGestionar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports